// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ae39e7b","455":"5c78605d"}[chunkId] + ".chunk.js";
};